import { useEffect, useRef, useState } from "react";
import type { TextPart } from "../../../../models/ManualAuthoring";
import "./structuredInlineTextEditor.css";

interface Props {
  textParts: TextPart[];
  onChange: (newParts: TextPart[]) => void;
  onDone: () => void;
}

export default function SimpleInlineTextEditor({
  textParts,
  onChange,
  onDone,
}: Props) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState(
    (textParts || [])
      .map((p) => (p.type === "text" ? p.value : p.label))
      .join("")
  );

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  const commitAndClose = () => {
    onChange([{ type: "text", value }]);
    onDone();
  };

  return (
    <div className="niquill-inline-editor">
      <div className="niquill-editor-toolbar">
        <button
          type="button"
          className="niquill-close-button"
          onMouseDown={(e) => e.preventDefault()}
          onClick={commitAndClose}
        >
          Close
        </button>
      </div>

      <textarea
        ref={textareaRef}
        className="niquill-inline-textarea"
        value={value}
        spellCheck={true}
        autoCorrect="on"
        autoCapitalize="sentences"
        onChange={(e) => setValue(e.target.value)}
        onBlur={commitAndClose}
      />
    </div>
  );
}
